import React from "react"

export default React.createContext({
  statsById: {},
  statsVisible: false,
  showStats: bool => {},
  request: id => {},
})
